import { Navigate, useLocation } from "react-router-dom";
import AuthLoadingScreen from "./AuthLoadingScreen";
import { useAuth } from "./useAuth";

const RequireConsent = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
          fromHash: window.location.hash || "",
        }}
      />
    );
  }

  if (user?.consent?.requiresConsent) {
    return (
      <Navigate
        to="/account/consent-required"
        replace
        state={{ returnTo: location.pathname + location.search }}
      />
    );
  }

  return children;
};

export default RequireConsent;
